import Secured from './Secured';

export default Secured;
